




















































































































































































































































































































































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxTooltip from '@/dex-shared/components/px-tooltip.vue';
import Pagination from '@/components/Pagination.vue';
import { Datetime } from 'vue-datetime';
import UEEPegasusPangareRequestService from '@/helpers/pegasus-pangare/request';

const weeklyAssessmentIdentifier = '[MATEMATICA|NATUREZA|HUMANAS|LINGUAGENS]';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    pxTooltip,
    PlusIcon,
    CloseIcon,
    ArrowRightIcon,
    Pagination,
    Datetime,
  },

  data() {
    return {
      creating: true,
      exams: [],
      pushingExamGroup: false,
      openedSelectorIndex: -1,
      currentExamsPage: 0,
      dataPointsExamId: null,
      searchingForBaseExamGroup: false,
      dataPointExam: null,
      examsToBeReferencedStart: null,
      examsToBeReferencedEnd: null,
    };
  },

  computed: {
    ...mapState({
      allExams: (state: any) => state.exams.exams,
      boards: (state: any) => state.boards.boards,
      boardSections: (state: any) => state.boardSections.board_sections,
      boardSubsections: (state: any) =>
        state.boardSubsections.board_subsections,
    }),
    ...mapGetters({
      examGroup: 'currentExamGroup',
      examGroupForReference: 'currentExamGroupForReference',
    }),
  },

  watch: {
    examGroup(newExamGroup) {
      if (newExamGroup && newExamGroup.exams) {
        this.exams = newExamGroup.exams.map(e => e.id);
      }
    },
  },

  async created() {
    this.creating = this.$route.name === 'exam_group_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_EXAM_GROUP');
    } else {
      let examGroupId = parseInt(this.$route.params.examGroupId);
      await this.$store.dispatch('PULL_EXAM_GROUP', examGroupId);
      //TODO no examGroup found
    }
    await Promise.all([
      this.$store.dispatch('PULL_BOARDS'),
      this.$store.dispatch('PULL_EXAMS', this.currentExamsPage),
    ]);
  },

  methods: {
    openSelector: function(index: number) {
      if (index == this.openedSelectorIndex) {
        this.openedSelectorIndex = -1;
      } else {
        this.openedSelectorIndex = index;
      }
    },
    hasAnyEmptyDate(exams) {
      return exams.filter(exam => !exam.start || !exam.end).length > 0;
    },
    pushExamGroup: async function() {
      const examsBeforePush = [...this.examGroup.exams];

      const upsertUeeCalendarEvents = async (
        oldExams: any[],
        newExams: any[],
        examGroupSlug: string,
      ) => {
        let errorOnUpdateUEECalendar = false;

        const isWeeklyAssessment = (description: string) =>
          description.toUpperCase().includes(weeklyAssessmentIdentifier);

        const deletedExams = oldExams.filter(
          oldExam =>
            !newExams.some(newExam => newExam.id === oldExam.id) &&
            isWeeklyAssessment(oldExam.description),
        );
        const insertedExams = newExams.filter(
          newExam =>
            !oldExams.some(oldExam => oldExam.id === newExam.id) &&
            isWeeklyAssessment(newExam.description),
        );

        const deleteEventsProcess = deletedExams.map(async deletedExam => {
          const result = await UEEPegasusPangareRequestService.deletePracticeExamCalendarEvents(
            {
              practiceExamId: deletedExam.id,
              practiceExamStartDate: deletedExam.start,
              dexExamGroups: [examGroupSlug],
            },
          );

          if (result.identifier !== 'CalendarEventDeleted')
            errorOnUpdateUEECalendar = true;
        });

        const upsertEventsProcess = insertedExams.map(async insertedExam => {
          const result = await UEEPegasusPangareRequestService.upsertPracticeExamCalendarEvents(
            {
              practiceExam: {
                id: insertedExam.id,
                name: insertedExam.name,
                slug: insertedExam.slug,
                description: insertedExam.description,
                startMomentIsoString: insertedExam.start,
              },
              dexExamGroups: [examGroupSlug],
            },
          );

          if (result.identifier !== 'CalendarEventUpserted')
            errorOnUpdateUEECalendar = true;
        });

        await Promise.all([...deleteEventsProcess, ...upsertEventsProcess]);

        if (errorOnUpdateUEECalendar)
          alert('Erro ao atualizar os eventos na agenda de UEE.');
      };

      if (this.dataPointExam && !this.pushingExamGroup) {
        if (this.hasAnyEmptyDate(this.dataPointExam.exams)) {
          alert('As datas de agendamento das provas não podem ser nulas.');
          return null;
        }
        this.pushingExamGroup = true;
        await this.$store.dispatch('PUSH_EXAM_GROUP_WITH_REFERENCE', {
          examGroup: this.examGroup,
          examGroupReference: this.dataPointExam,
        });
        await upsertUeeCalendarEvents(
          examsBeforePush,
          this.examGroup.exams,
          this.examGroup.slug,
        );
        this.pushingExamGroup = false;
        if (this.examGroup.id)
          this.$router.push(`/simulado/${this.examGroup.id}`);
      } else {
        this.examGroup.exams = this.exams.sort((a, b) => a - b);
        //TODO valid examGroup
        if (this.pushingExamGroup === false) {
          this.pushingExamGroup = true;
          await this.$store.dispatch('PUSH_EXAM_GROUP', this.examGroup);
          await upsertUeeCalendarEvents(
            examsBeforePush,
            this.examGroup.exams,
            this.examGroup.slug,
          );
          this.pushingExamGroup = false;
          //TODO error inputing exam group
          if (this.examGroup.id) {
            if (this.creating) {
              this.$router.push(`/simulado/${this.examGroup.id}`);
            } else {
              this.$router.go(-1);
              this.$router.push(`/simulado/${this.examGroup.id}`);
            }
          }
        }
      }
    },
    searchForBaseExamGroup: async function() {
      if (!this.dataPointsExamId) {
        alert('O campo de ID está nulo.');
        return null;
      }
      if (!this.examGroup.name || !this.examGroup.description) {
        alert(
          'Você primeiro tem que preencher o nome e a descrição desse simulado',
        );
        return;
      } else {
        this.searchingForBaseExamGroup = true;
        const examGroup = await this.$store.dispatch(
          'PULL_EXAM_GROUP_FOR_REFERENCE',
          this.dataPointsExamId,
        );
        this.searchingForBaseExamGroup = false;
        if (Object.keys(this.examGroupForReference).length === 0) {
          alert('Não foi encontrado nenhum simulado com esse ID');
          await this.onCancelMirroringClicked();
        } else {
          this.dataPointExam = this.examGroupForReference;
        }
      }
    },
    goToExamGroup() {
      this.$router.push('/');
    },
    openExam(examId: number) {
      let route = this.$router.resolve({
        path: `/prova/${examId}`,
      });
      window.open(route.href, '_blank');
    },
    addMaterial: async function(payload: {
      examGroupId: number;
      boardId: number;
      boardSectionsId: number;
      boardSubsectionsId: number;
    }) {
      try {
        await this.$store.dispatch('ADD_MATERIAL', payload);
      } catch (e) {
        alert(
          `Ocorreu um erro associando esse material. Por favor envie essa mensagem aos desenvolvedores: ${e}`,
        );
      }
      const examGroupId = parseInt(this.$route.params.examGroupId);
      await this.$store.dispatch('PULL_EXAM_GROUP', examGroupId);
    },
    removeMaterial: async function(materialId: number) {
      if (confirm('Tem certeza?')) {
        await this.$store.dispatch('REMOVE_MATERIAL', materialId);
        let examGroupId = parseInt(this.$route.params.examGroupId);
        await this.$store.dispatch('PULL_EXAM_GROUP', examGroupId);
      }
    },
    changePage: async function(event: any) {
      this.currentExamsPage = event;
      await this.$store.dispatch('PULL_EXAMS', this.currentExamsPage);
    },
    onCancelMirroringClicked: async function() {
      this.dataPointsExamId = null;
      this.searchingForBaseExamGroup = false;
      this.dataPointExam = null;
      this.$store.commit('SET_EXAM_GROUP_FOR_REFERENCE', null);
    },
  },
});
